import { render, staticRenderFns } from "./formBlockContent.vue?vue&type=template&id=535bb7ac&scoped=true&"
import script from "./formBlockContent.vue?vue&type=script&lang=babel&"
export * from "./formBlockContent.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535bb7ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
